import { IAttachment } from 'src/app/shared/attachments/models/attachments.model';
import { IStock } from 'src/app/shared/models/stock.model';
import { IChemicalExposureRequest } from './chemical-exposure.model';

export interface IUseProduct {
  storageProductId: string;
  amountUsed: number;
  reasonForUse: string;
  adjustmentAttachments: IAttachment[];
  chemicalExposure?: IChemicalExposureRequest;
}

export function mapStock(stock: IStock): IUseProduct {
  const useProduct: IUseProduct = {
    storageProductId: stock.id,
    amountUsed: stock.amount,
    reasonForUse: stock.reason,
    adjustmentAttachments: stock.adjustmentAttachments,
  };
  if (stock.chemicalExposure) {
    useProduct.chemicalExposure = stock.chemicalExposure;
  }
  return useProduct;
}
